module.exports = __webpack_public_path__ + "media/images/product_lines/travel/main_m-ff7c66472b7c46603c9c4771c723aed5.svg";